import $ from 'jquery';
import React from 'react';
import PreLoginPage from '../../../views/core/PreLoginPage';

import NativeAjax from '../../../util/NativeAjax';

const currency_map = {
    "INR":"₹ ",
    "SGD":"SG $"
}
const redirection_url_key = "login-redirect-purchase";

class FlipBox  extends PreLoginPage {

    constructor(props){
        super(props)
        this.state = {
            isLoaded: false,
            forceUpdater: 1
        };
        this.OPSAvailable = false;
        this.productDetails = props.productDetails || {};

        this.teacherLessonsList = {};

        if(typeof props.teacherLessonsList === "object"){
            for(let i in props.teacherLessonsList){
                this.teacherLessonsList[i] = props.teacherLessonsList[i];
            }
        }

        this.isFreeProduct = false;
        this.isFreeTrialAvailable = true;
        this.isUserLoggedIn = false;
     
        try{
            this.isFreeProduct = ((!isNaN(props.gradeBox.productPrice) && parseInt(props.gradeBox.productPrice) === 0 )|| (!isNaN(props.gradeBox.nonDiscountedPrice) && parseInt(props.gradeBox.nonDiscountedPrice) === 0));
        }catch(e){}        

        this.className =  props.gradeName;
        this.billingForm = this.billingForm.bind(this);
        this.getCurrency = this.getCurrency.bind(this);

        this.tryForFree = this.tryForFree.bind(this);

    }

    componentDidMount(){
        super.componentDidMount();
        this.checkFreeTrailFn();
    }

    checkFreeTrailFn = () => {
        //console.warn("checkFreeTrailFn ");
        if(this.props.gradeBox){
            this.isUserLoggedIn = (this.getUser().getUserId() && this.getUser().getUserId().length > 0) ? true : false;
            this.isFreeProduct = ((!isNaN(this.props.gradeBox.productPrice) && parseInt(this.props.gradeBox.productPrice) === 0 )|| (!isNaN(this.props.gradeBox.nonDiscountedPrice) && parseInt(this.props.gradeBox.nonDiscountedPrice) === 0));
            if(this.isFreeProduct && this.isUserLoggedIn){
                this.checkUserFreeTrial();
            }
        }
    }

    showSubscriptionForm(callback){
        sessionStorage.setItem(redirection_url_key, window.location.href);
        if(typeof this.props.showSubscriptionForm === "function"){
            this.props.showSubscriptionForm(callback);
        }
    }

    checkUserFreeTrial(){
          const me = this;
          const success = (resp) => {
                if(resp && resp.response && (resp.response.paid_accessed === false && resp.response.free_accessed === false)){
                    me.isFreeTrialAvailable = true;
                    me.setState({forceUpdater: (me.state.forceUpdater + 1)})
                }else{
                    me.markUsed();
                }
            }

            const failure = (err) => {
                console.warn("lalala :: failure");
            }

            const productPurchaseParams = {};
            productPurchaseParams["products"] = [];
            const prodObj = {"productId":this.props.gradeBox.productId,"tariffId":this.props.gradeBox.tariffId};
            productPurchaseParams["products"].push(prodObj);
              

          const sendToServer = () =>{
            new NativeAjax(this.getUrlFor("FREE_PRODUCT_CHECK"),productPurchaseParams).enableCORS().post(success,failure);
          }

          if(this.isUserLoggedIn){
           sendToServer();           
          }else{
            this.showSubscriptionForm(sendToServer);
          }          
    }

    tryForFree(){
        const me = this;
        const success = (resp) => {
            if(resp && resp.response === "success"){
                window.top.location.href = "/myproducts";
                return;
            }else{
                me.markUsed();
            }
            window.location.reload();
        }

        const failure = (err) => {            
            window.location.reload();
        }

        const productPurchaseParams = {};
        productPurchaseParams["products"] = [];
        const prodObj = {"productId":this.props.gradeBox.productId,"tariffId":this.props.gradeBox.tariffId};
        productPurchaseParams["products"].push(prodObj);


        const sendToServer = () =>{
            new NativeAjax(this.getUrlFor("FREE_PRODUCT_SAVE"),productPurchaseParams).enableCORS().post(success,failure);  
        }

        if(this.isUserLoggedIn){
           sendToServer();           
        }else{
            this.showSubscriptionForm(sendToServer);
        }
    }

    markUsed(){
         this.isFreeTrialAvailable = false;
         this.setState({forceUpdater: (this.state.forceUpdater + 1)})
    }

    billingForm(evt){
        let productList={
            "productId":this.props.gradeBox.productId,
            "productCategory":this.props.gradeBox.productCategory,
            "currency":this.props.gradeBox.currency,
            "productName":this.props.gradeBox.productName,
            "productPrice":this.props.gradeBox.productPrice,
            "productTariffID":this.props.gradeBox.tariffId,
            "validity":this.props.gradeBox.validity,
            "tariffId":this.props.gradeBox.tariffId,
            "count":1,
            "basePrice":this.props.gradeBox.productPrice,
            "appName":this.props.appDetails.appName,
            "appId":this.props.appDetails.appId,
            "gradeName":this.props.gradeName
        };
        this.props.showBillingForm(productList)
    }

    getLessonsList(){
        let tempObj = this.props.teacherLessonsList || {};
        if(tempObj && Object.keys(tempObj).length > 0){
            return (
                <ul>
                {Object.keys(tempObj).map((data, idx) => {
                    if(data && !isNaN(tempObj[data]) && tempObj[data] > 0){
                        return (
                            <li key={idx}><span className="topcnt">{tempObj[data] || 0}</span> {this.rb("label."+data)}</li>
                        );
                    }
                })
                }
               </ul>
            )
        }
    }

    getCurrency(currency=""){
        if(currency && currency.length > 0){
            return (currency_map[currency.toUpperCase()]) ? currency_map[currency.toUpperCase()] : currency.toUpperCase();
        }

        return currency;
    }

    getDiscountPercent(originalPrice, discountedPrice){

        if(!isNaN(originalPrice) && !isNaN(discountedPrice)){
            try{
            return Math.round(((originalPrice-discountedPrice)/ originalPrice) * 100);

            }catch(e){
                console.error("Error calculating discount :: ", e);
            }
        }

        return 0;
    }

    renderPrice(){
        var me = this;
        if(me.props.gradeBox.nonDiscountedPrice){
            let productPrice = this.getCurrency(me.props.gradeBox.currency)+ Math.round(me.props.gradeBox.productPrice);
            let nonDiscountedPrice = this.getCurrency(me.props.gradeBox.currency)+Math.round(me.props.gradeBox.nonDiscountedPrice);
            let disPercentage = me.getDiscountPercent(me.props.gradeBox.nonDiscountedPrice,me.props.gradeBox.productPrice)+"% off";
            return  (
                <span className="couponprice">
                    <span className="orgprice"><span className="striketxt">
                        {/* <i className="fa">&#xf156;</i> */}
                        {nonDiscountedPrice || ''}</span></span>
                      <br/>
                     <span className="discntprice">
                      {/* <i className="fa">&#xf156;</i>  */}
                         {productPrice || ''}</span>
                         <span className="discntper">{disPercentage}</span>
                </span>
            )
        }else if(this.isFreeProduct){
            return(
             <span>
                {this.rb("product.buyoption.freetrail").replace("{0}",me.props.gradeBox.validity)}
             </span>
            )
        }
        return (
        <span>
             {/* <i className="fa">&#xf156;</i>  */}
             {this.getCurrency(me.props.gradeBox.currency)} {Math.round(this.props.gradeBox.productPrice) || ''}</span>
        ) 
    }

    getProductPrice = () =>{
        let me = this;
        if(this.props.gradeBox.productPrice > 0){
            return(
                <span>
                {this.getCurrency(me.props.gradeBox.currency)} {Math.round(this.props.gradeBox.productPrice) || ''}
                </span>
            )
        }else{
           return(
            <span>
            {Math.round(this.props.gradeBox.productPrice) || this.rb("flipbox.price.free")}
            </span>
           )
        }
    }

    renderProductview(){
        var me = this;
        if(me.props.gradeBox.nonDiscountedPrice){
            let productPrice = this.getCurrency(me.props.gradeBox.currency)+ Math.round(me.props.gradeBox.productPrice);
            let nonDiscountedPrice = this.getCurrency(me.props.gradeBox.currency)+Math.round(me.props.gradeBox.nonDiscountedPrice);
            let disPercentage = me.getDiscountPercent(me.props.gradeBox.nonDiscountedPrice,me.props.gradeBox.productPrice)+"% off";

            const txtalign = { textAlign:"left"}
            return (
                <div className="row">
                    <div className="col-7 greyborderright" style={txtalign}> 
                    <span className="couponprice">
                    <span className="orgprice"><span className="striketxt">
                        {nonDiscountedPrice || ''}</span></span>
                      <br/>
                     <span className="discntprice">
                         {productPrice || ''}</span>
                         <span className="discntper">{disPercentage}</span>
                </span>
                </div>
                <div className="col-5 valyear"><span>Validity:&nbsp;</span><br/>{this.props.gradeBox.validity + ' days' || ''}
                </div>
                    </div>
            )
            
        }else{
            const txtalign = { textAlign:"center"}
            return (
                <div className="row">
                    <div className="col-5 greyborderright" style={txtalign}> 
                    {
                        this.getProductPrice()
                    }
                </div>
                <div className="col-7 valyear"><span>Validity:&nbsp;</span>{this.props.gradeBox.validity + ' days' || ''}
                </div>
                    </div>
            )
        }
        
    }

    getImageUI = () => {
        let me=this;
        let category = me.props.category || 'TCHR_SPL';
        let prodImgNotAvail = window.prodImgNotAvail || [];
        let imageAvailable = (category.length>1 && prodImgNotAvail.indexOf(category) > -1 ) ? true : false;
    
        //console.warn("prodImgNotAvail ",prodImgNotAvail , " : ",category," : ",imageAvailable);
        
        if(!imageAvailable){
            return(
                <div className="row toprow">
                <div className="col-12 col-lg-5"><img src={"/"+me.productDetails.thumbnails} alt={me.props.gradeBox.productName || ''}></img></div>
                <div className="col-12 col-lg-7 topicinfo">
    
                {me.getLessonsList()}
    
                </div>
                </div>
            )
        }
    }

    render(){
        const me = this;
        this.OPSAvailable = this.props.OPSAvailable || false;
        let opsClass = (this.OPSAvailable == true) ? 'opsenabled':'opsdisabled'
        this.productDetails = this.props.productDetails || {};
        me.isFreeProduct = ((!isNaN(me.props.gradeBox.productPrice) && parseInt(me.props.gradeBox.productPrice) === 0 )|| (!isNaN(me.props.gradeBox.nonDiscountedPrice) && parseInt(me.props.gradeBox.nonDiscountedPrice) === 0));
        this.className =  this.props.gradeName || '';
        let addClass = me.isFreeProduct ? ' freetrail':''
        return(
           <div className="flipbox">
                <div className="card">
        <div className="card-header">{this.props.gradeBox.productName || ''}</div>
            <div className="card-body">
            {this.getImageUI()}
              
                <div className="card-text"><span className="text-heading">Concepts covered:&nbsp;</span>
                {this.productDetails.topics || ''}</div>
               
            </div>

            <div className="card-footer row">
                <div className="col-sm-8 col-lg-8 bottrow">
                   
                  {this.renderProductview()}
                  
                </div>
                <div className="col-sm-4 col-lg-4">
                    {(() => {
                        if(me.isFreeProduct && this.state.forceUpdater){
                            if(me.isFreeTrialAvailable){
                                return <div className="r-btn freetrail"><button data-ga="Home - Sign In - Users who have independently registered  - Sign In" className={"submitButton "+opsClass} data-tarrifid={this.props.gradeBox.tariffId} data-productid={this.props.gradeBox.productId} data-gradeid={this.props.gradeName} data-category={this.props.gradeBox.productCategory} onClick={this.tryForFree}>{this.rb("flipbox.trynow")}</button></div>
                            }else{
                                return <div className="r-btn opsdisabled freetrail"><button data-ga="Home - Sign In - Users who have independently registered  - Sign In" className={"submitButton "+opsClass} data-tarrifid={this.props.gradeBox.tariffId} data-productid={this.props.gradeBox.productId} data-gradeid={this.props.gradeName} data-category={this.props.gradeBox.productCategory} >{this.rb("flipbox.subscribed")}</button></div>    
                            }                            
                        }else{
                            return <div className="r-btn"><button data-ga="Home - Sign In - Users who have independently registered  - Sign In" className={"submitButton "+opsClass} data-tarrifid={this.props.gradeBox.tariffId} data-productid={this.props.gradeBox.productId} data-gradeid={this.props.gradeName} data-category={this.props.gradeBox.productCategory} onClick={this.billingForm}>{this.rb("flipbox.subscribe")}</button></div>
                        }
                    })()}                    
                </div>
            </div>

            </div>
           
            </div>
            
        )
    }

}

export default FlipBox;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/FlipBox.js